export const stripNotAllowed = (s) => s.replace(/[^a-z0-9.-]/gi, '');

export const checkUID = (inVal, forceLowerCase = false, separator = ".") => {
    // console.log('checkUID:', inVal, forceLowerCase, separator);
    let def = [ '' ];
    if(inVal) {
        const val = forceLowerCase ? inVal.trim().toLowerCase() : inVal.trim();
        def = val.split(separator).map(u => stripNotAllowed(u)).filter(u => u.length);
    }
    return def.join(separator);
};

export const checkUIDOld = (inVal, forceLowerCase = false, separator=".") => {
    const def = [ 'example', 'iconpack' ];
    if(inVal && inVal.includes(separator)) {
        const val = forceLowerCase ? inVal.trim().toLowerCase() : inVal.trim();
        const a = val.split(separator).map(u => stripNotAllowed(u)).filter(u => u.length >= def.length);
        const maxLen = Math.max(a.length, def.length);
        for(let i = 0;i < maxLen;i++) {
            if(a[i] && a[i].length) {
                def[i] = a[i];
            }
        }
    }
    // return def.join('.');
    return def.join(separator);
};
